module.exports = __webpack_public_path__ + "static/1.0_543x300_Golfer_Mobile_2X-cadfb889a0a04a17577257adaed25a52.png";